import { useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { api } from "@/lib/api";

export default function RecipientsEditor({ recipients, onChange }) {
  const [draft, setDraft] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (next) => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/digest/recipients", { recipients: next });
      onChange(data.recipients);
      return true;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update recipients");
      return false;
    } finally { setBusy(false); }
  };

  const add = async () => {
    const e = draft.trim().toLowerCase();
    if (!e) return;
    if (recipients.includes(e)) { toast.info("Already on the list"); setDraft(""); return; }
    if (await save([...recipients, e])) { setDraft(""); toast.success(`${e} added ✓`); }
  };

  const remove = async (e) => {
    if (recipients.length === 1) { toast.error("Keep at least one recipient"); return; }
    if (await save(recipients.filter((x) => x !== e))) toast.success(`${e} removed`);
  };

  return (
    <div className="recip-box" data-testid="digest-recipients-editor">
      <div className="recip-list">
        {recipients.map((e) => (
          <span className="recip-chip" key={e} data-testid={`recipient-chip-${e}`}>
            {e}
            <button onClick={() => remove(e)} disabled={busy} aria-label={`Remove ${e}`} data-testid={`recipient-remove-${e}`}><X size={12} /></button>
          </span>
        ))}
        {recipients.length === 0 && <span style={{ fontSize: 12, opacity: .6 }}>No recipients yet</span>}
      </div>
      <form className="recip-add" onSubmit={(e) => { e.preventDefault(); add(); }}>
        <input type="email" className="admin-search" placeholder="Add an email address…" value={draft} onChange={(e) => setDraft(e.target.value)} disabled={busy} data-testid="recipient-add-input" />
        <button type="submit" className="btn-yellow" disabled={busy || !draft.trim()} style={{ width: "auto", padding: "8px 16px", fontSize: 13 }} data-testid="recipient-add-btn"><Plus size={14} style={{ verticalAlign: "-2px", marginRight: 4 }} />Add</button>
      </form>
    </div>
  );
}
